import * as React from "react";

const CategoryIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
  >
    <g fill="inherit" clipPath="url(#clip0_1462_903)">
      <path d="M7.281 7.823H3.39a1.49 1.49 0 0 1-1.487-1.486V2.494A1.49 1.49 0 0 1 3.39 1.008H7.28a1.49 1.49 0 0 1 1.486 1.486v3.843a1.49 1.49 0 0 1-1.486 1.486M3.39 2.159a.336.336 0 0 0-.336.335v3.843a.336.336 0 0 0 .336.335H7.28a.336.336 0 0 0 .335-.335V2.494a.336.336 0 0 0-.335-.335zM7.3 15.882H3.408a1.49 1.49 0 0 1-1.486-1.487v-3.843a1.49 1.49 0 0 1 1.486-1.486H7.3a1.49 1.49 0 0 1 1.485 1.486v3.843A1.49 1.49 0 0 1 7.3 15.882m-3.892-5.665a.336.336 0 0 0-.335.335v3.843a.336.336 0 0 0 .335.336H7.3a.336.336 0 0 0 .335-.336v-3.843a.336.336 0 0 0-.335-.335zM15.292 15.882H11.4a1.49 1.49 0 0 1-1.486-1.487v-3.843A1.49 1.49 0 0 1 11.4 9.066h3.892a1.49 1.49 0 0 1 1.486 1.486v3.843a1.487 1.487 0 0 1-1.486 1.487M11.4 10.22a.336.336 0 0 0-.335.335v3.843a.336.336 0 0 0 .335.335h3.892a.336.336 0 0 0 .335-.335v-3.846a.336.336 0 0 0-.335-.335zM13.348 7.823a3.407 3.407 0 1 1 3.432-3.407 3.424 3.424 0 0 1-3.432 3.407m0-5.663a2.256 2.256 0 1 0 2.28 2.256 2.27 2.27 0 0 0-2.28-2.258z"></path>
    </g>
    <defs>
      <clipPath id="clip0_1462_903">
        <path fill="#fff" d="M.781.893h16.111v16.11H.782z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CategoryIcon;
